export function POStatusBanner({
  poNumber,
  poStatus,
  needsManager,
}: {
  poNumber: string | null;
  poStatus: string | null;
  needsManager: boolean;
}) {
  if (!poNumber) return null;
  const color = needsManager ? "#7c3aed" : "#2f9e44";
  const bg = needsManager ? "#f5f0ff" : "#f0fff4";
  return (
    <div
      style={{
        background: bg,
        border: `1px solid ${color}44`,
        borderRadius: 6,
        padding: "10px 14px",
        marginTop: 12,
        fontSize: 13,
      }}
    >
      <span style={{ fontWeight: 700, color }}>
        {needsManager ? "⏳ PO pending manager approval" : "✓ PO generated"}
      </span>
      <span style={{ color: "#555", marginLeft: 8 }}>
        {poNumber}
        {poStatus && (
          <span
            style={{
              marginLeft: 8,
              padding: "1px 6px",
              borderRadius: 3,
              background: `${color}22`,
              color,
              fontSize: 11,
              fontWeight: 600,
            }}
          >
            {poStatus}
          </span>
        )}
      </span>
      {needsManager && (
        <div style={{ color: "#666", marginTop: 4, fontSize: 12 }}>
          A manager or admin must approve this PO before it is dispatched to the
          supplier. Go to the <strong>Purchase Orders</strong> tab.
        </div>
      )}
    </div>
  );
}
